module.exports = __webpack_public_path__ + "static/media/intro.11850356.mp3";